exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:700px){.item-contenedor-busqueda[data-v-48bac5fe]{width:500px;margin-left:110px}.field-busqueda[data-v-48bac5fe]{width:500px}}.has-text-filekom[data-v-48bac5fe]{color:#243c68}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48bac5fe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Header.vue
// module id = 222
// module chunks = 58